// Which mode this device is in, for the signed-in person and business (docs/plans/stations.md).
import { useState } from 'react'
import { useOnline } from '../hooks.ts'
import { useStation, type StationMode } from '../lib/station.ts'
import { useUser } from '../session.tsx'
import { useWorkspace } from '../workspace.tsx'

export function useDeviceStation(): StationMode {
  const user = useUser()
  const { current } = useWorkspace()
  return useStation(user.id, current?.tenant_id)
}

/** When the connection dropped, while it is down. */
export function useOfflineSince(): string | null {
  const online = useOnline()
  const [since, setSince] = useState<string | null>(null)
  if (online && since) setSince(null)
  if (!online && !since) setSince(new Date().toISOString())
  return since
}
